// extracted by mini-css-extract-plugin
export default {"modal":"hR-z","sharingIconsV2":"iR-z","notificationBox":"jR-z","checkMark":"kR-z","textFrame":"lR-z"};